var StarDrawRedirector = xClass("StarDrawRedirector", BaseRedirector)
StarDrawRedirector.prototype.getName = function () {
    return "newchest_big"
}
StarDrawRedirector.prototype.redirect = function () {
    cc.log("----StarDrawRedirector redirect----")
    var self = this
    var param = self.param

    if (!_G.isGetNewUserReward) {
        var inviteCode = param.inviteCode;
        var shareId = param.bigRewardShareId;
        var http = DoStarRewardInviteHttp.new();
        http.load(inviteCode, shareId);
            
        return true
    }else{
        return false
    }
}

StarDrawRedirector.prototype.hasHighPriorityAction = function () {
    return false;
}

module.exports = StarDrawRedirector